/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectHotelName,
  selectEnableHotelGroups,
  selectLocalCurrency,
} from 'modules/dashboard/selectors';
import { generateExportShareUrl } from 'modules/dashboard/components/tab-container/inner-filter/functions';
import { workbookActions } from 'modules/dashboard/components/tab-container/workbook-report/slice';
/**
 * Custom hook to generate export widget share url
 */
const useExportWidget = () => {
  const dispatch = useDispatch();
  //
  const hotelId = useSelector(selectHotelName);
  const enableHotelGroups = useSelector(selectEnableHotelGroups);
  const localCurrency = useSelector(selectLocalCurrency);

  // Triggers when filter values dependencies changes
  useEffect(() => {
    if (!localCurrency && !hotelId) return;
    // Generate export filter url
    const workbookUrl = generateExportShareUrl(hotelId, enableHotelGroups, localCurrency);
    //
    dispatch(workbookActions.setExportUrl(workbookUrl));
  }, [hotelId, enableHotelGroups, localCurrency]);
};
//
export default useExportWidget;
